import { EntityType } from '@/plugins/cad/module/CADModule/model/common/constant'
import type { IPoint } from '@/plugins/cad/module/CADModule/model/common/interface'
import { ArcUtils } from '@/plugins/cad/module/utils/ArcUtils'
import { BaseEntity } from './BaseEntity'

/**
 * 圆弧实体，以圆心、半径、起止角定义。
 */
export class ArcEntity extends BaseEntity {
  /** 圆弧圆心 */
  center!: IPoint
  /** 圆弧半径，单位米 */
  radius!: number
  /** 起始角，单位弧度 */
  startAngle!: number
  /** 终止角，单位弧度 */
  endAngle!: number
  /** 是否为顺时针方向 */
  clockwise: boolean = false

  /** 渲染采样段数，不参与序列化 */
  segmentsNum?: number

  protected readonly serializeKeys: string[] = [
    'center',
    'radius',
    'startAngle',
    'endAngle',
    'clockwise',
  ]

  constructor(data: Partial<ArcEntity>) {
    super(EntityType.Arc)
    Object.assign(this, data)
  }

  /**
   * 获取捕捉数据，返回圆心、起点、终点和中点。
   *
   * 圆弧的线段捕捉较复杂，暂不实现。
   *
   * @returns 包含端点、中点与圆心的捕捉数据
   */
  getCaptureData() {
    const endPoints: IPoint[] = []
    const midPoints: IPoint[] = []

    // 起点
    endPoints.push({
      x: this.center.x + this.radius * Math.cos(this.startAngle),
      y: this.center.y + this.radius * Math.sin(this.startAngle),
    })

    // 终点
    endPoints.push({
      x: this.center.x + this.radius * Math.cos(this.endAngle),
      y: this.center.y + this.radius * Math.sin(this.endAngle),
    })

    // 中点（弧的中间角度）
    const sweep = ArcUtils.getSweepAngle(this.startAngle, this.endAngle, this.clockwise)
    const midAngle = this.startAngle + (this.clockwise ? -sweep / 2 : sweep / 2)
    midPoints.push({
      x: this.center.x + this.radius * Math.cos(midAngle),
      y: this.center.y + this.radius * Math.sin(midAngle),
    })

    return {
      endPoints,
      midPoints,
      centerPoints: [{ x: this.center.x, y: this.center.y }],
    }
  }
}
